import { CSSObject } from "@emotion/react";
import { constants } from "@newsela/angelou";

const COLLAPSING_BREAKPOINT = "@media (max-width: 576px)";

export const breadcrumbContainerCss: CSSObject = {
  display: "flex",
  flexWrap: "nowrap",
  overflow: "hidden",
  whiteSpace: "nowrap",
  // Without this trick, the container gets a fixed width of 1403px when the
  // screen gets small enough to collapse the side-panel.
  width: 0,
  minWidth: "100%",
};

export const breadcrumbItemCss = (isLast: boolean): CSSObject => ({
  display: "block",
  color: isLast
    ? constants.colors.ui.black[700]
    : constants.colors.ui.neutral[500],
  fontWeight: isLast ? 600 : 400,
  textDecoration: "none",

  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",

  "&:hover": {
    textDecoration: isLast ? "none" : "underline",
  },
});

export const itemSeparatorCss: CSSObject = {
  margin: "0 8px",
  color: constants.colors.ui.neutral[500],
};

export const collapsingEllipsisCss = (showToAnySize: boolean): CSSObject => ({
  display: showToAnySize ? "block" : "none",
  margin: "0 0 0 8px",
  color: constants.colors.ui.neutral[500],

  [COLLAPSING_BREAKPOINT]: {
    display: "block",
  },
});

export const xmallHideCss: CSSObject = {
  [COLLAPSING_BREAKPOINT]: {
    display: "none",
  },
};
